// extracted by mini-css-extract-plugin
module.exports = {"root":"RangeSlider_root__3ZCzC","activeHandle":"RangeSlider_activeHandle__24eu0"};